import { Suspense, type ReactNode } from 'react';
import { LoadingScreen } from '@/components/ui/loading-screen';

interface LazyPageProps {
  children: ReactNode;
}

/**
 * Wrapper para lazy-loaded pages com fallback
 */
export function LazyPage({ children }: LazyPageProps) {
  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
}
